import {DefaultResType, ErrorType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {PostExternalProductReadUserBeforeOrderListApiForm, ProductExSearchParamType} from "../../pages/product/external/list/interface";
import { productSideSearchParams } from '../../pages/product/external/list/state/index';
import {
    ProductExDetailBeforeOrderListSearchParamType,
    ProductExDetailSearchParamType
} from "../../pages/product/external/detail/interface";

const url = "api/external/product/";

export async function readProductByDoubleFilterEx(param: ProductExSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_product_by_double_filter", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readProductDetailEx(param: ProductExDetailSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_product_detail", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateProductDetailImageEx(data: FormData): Promise<DefaultResType> {
    try {
        return await baseApi.post("api/external/product/" + "update_image", data, {headers: {"Content-Type": "multipart/form-data"}});
    } catch (err: any) {
        return err?.response;
    }
}

export async function readBeforeOrderListEx(param: ProductExDetailBeforeOrderListSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_before_order_list", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function deleteProductEx(data: ProductExDetailSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "delete_product", data);
    } catch (err: any) {
        return err?.response;
    }
}


export async function downloadProductImage(data: {
    fileId: number;
    fileKey: string;
    fileOrgname: string
}): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.get("api/file/images_download", {
        params: data,
        responseType: "blob",
    });

    return response?.data;
}

// export async function uploadProductCurrencyExcelIn(data: FormData): Promise<DefaultResType> {
//     try {
//         return await baseApi.post(url + "upload_product_currency_excel", data, {headers: {"Content-Type": "multipart/form-data"}});
//     } catch (err: any) {
//         return err?.response;
//     }
// }
//
// export async function exportProductExcelIn(param: ProductInSearchParamType): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
//     const response = await baseApi.post(url + "export_product_excel", param, {
//         responseType: "blob",
//     });
//
//     return response?.data;
// }
//
// export async function readProductDetailIn(data: ProductInDetailSearchParamType): Promise<DefaultResType> {
//     try {
//         return await baseApi.post(url + "read_product_detail", data);
//     } catch (err: any) {
//         return err?.response;
//     }
// }
//
// export async function updateProductDetailImageIn(data: FormData): Promise<DefaultResType> {
//     try {
//         return await baseApi.post(url + "update_image", data, {headers: {"Content-Type": "multipart/form-data"}});
//     } catch (err: any) {
//         return err?.response;
//     }
// }
//
// export async function deleteProductDetailImageIn(data: {
//     erpProductImageId: number,
//     newErpProductid: string
// }): Promise<DefaultResType> {
//     try {
//         return await baseApi.post(url + "delete_image", data);
//     } catch (err: any) {
//         return err?.response;
//     }
// }

export async function postExternalProductReadUserBeforeOrderListApi (data: PostExternalProductReadUserBeforeOrderListApiForm): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_user_before_order_list", data);
    } catch (err: any) {
        return err?.response;
    }
}